import { BehaviorSubject, Observable } from 'rxjs';
import { Disposable } from '../../hooks/useConstant';
import { LicenseWizardState } from '../../models/LicenseData';
import { createServiceModule } from '@aesop-fables/containr';

export const licenseWizardKey = 'services/licenseWizard';

class LicenseWizard implements Disposable {
  private readonly state: BehaviorSubject<LicenseWizardState | undefined> = new BehaviorSubject<
    LicenseWizardState | undefined
  >(undefined);

  constructor() {}

  get state$(): Observable<LicenseWizardState | undefined> {
    return this.state;
  }

  setState(state: LicenseWizardState) {
    this.state.next(state);
  }

  reset() {
    this.state.next(undefined);
  }

  dispose(): void {
    console.log('disposing LicenseWizard');
  }
}

export const withLicenseWizard = createServiceModule(licenseWizardKey, (services) => {
  services.use<LicenseWizard>(licenseWizardKey, LicenseWizard);
});

export { LicenseWizard };
